export const description =
  "Le bilan énergétique est la première analyse simplifiée de votre logement avant rénovation. Souvent gratuit, il identifie les principaux postes de déperdition et oriente vers les aides 2026.";
